import {Button, type ButtonProps} from '@mantine/core'
import {useCallback} from 'react'
import {useStripe} from '../../../providers/stripe/useStripe.ts'

export const ManageSubscriptionButton = ({...rest}: ButtonProps) => {
  const {createPortalSession, creatingPortalSession} = useStripe()

  const handleClick = useCallback(async () => {
    const response = await createPortalSession()
    const link = response?.link
    if (!link) return
    window.open(link, '_blank')
  }, [createPortalSession])

  return (
    <Button
      {...rest}
      onClick={handleClick}
      variant={'subtle'}
      size={'compact-sm'}
      fullWidth={false}
      loading={creatingPortalSession}
    >
      Manage subscription
    </Button>
  )
}
